// Leaf cart drawer extras: "+ Ajouter" upsell buttons and the "Complétez Votre Routine" carousel arrows.
// (Chillow warranty / auto-gift / overlay logic removed — the drawer overlay is pure CSS, see assets/leaf-cart.css.)
import { CartLinesUpdateEvent } from '@shopify/events';

const SECTION = 'cart-drawer-section';

// Same flow as Horizon's product-form: dispatch CartLinesUpdateEvent, post, resolve with the re-rendered section
async function add(id, source = 'leaf-cart-upsell') {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise })
  );
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: SECTION, sections_url: window.location.pathname }),
    }).then((r) => r.json());
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, source, sections: res.sections, didError: !!res.status },
    });
  } catch (error) {
    deferred.reject(error);
  }
}

function updateNav(track) {
  const reco = track.closest('.leaf-cart__reco');
  if (!reco) return;
  const max = track.scrollWidth - track.clientWidth - 1;
  const [prev, next] = reco.querySelectorAll('[data-leaf-cart-nav]');
  if (prev) prev.disabled = track.scrollLeft <= 1;
  if (next) next.disabled = track.scrollLeft >= max;
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-cw-add]');
  if (btn) {
    e.preventDefault();
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    await add(btn.dataset.cwAdd);
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    return;
  }
  const nav = e.target.closest('[data-leaf-cart-nav]');
  if (nav) {
    const track = nav.closest('.leaf-cart__reco')?.querySelector('[data-leaf-cart-track]');
    const card = track?.querySelector('.leaf-cart__card');
    if (!track || !card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(card.parentElement).columnGap || '0');
    track.scrollBy({ left: Number(nav.dataset.leafCartNav) * step, behavior: 'smooth' });
  }
});

document.addEventListener(
  'scroll',
  (e) => {
    const t = e.target;
    if (t instanceof Element && t.matches('[data-leaf-cart-track]')) updateNav(t);
  },
  { capture: true, passive: true }
);
